import { BlokProps } from "@/helpers/StoryblokHelpers"
import OpenNewTabIcon from "@/layout/icons/OpenNewTabIcon"
import { useConfigStore } from "@/store/config-store"
import { SourceLinkStoryblok } from "@/types/component-types"
import Link from "next/link"

export const SourceLink = ({ blok }: BlokProps<SourceLinkStoryblok>) => {
  const strings = useConfigStore.getState().strings
  return (
    <Link
      href={blok.link?.cached_url || "#"}
      target="_blank"
      rel="noopener norefferer"
      className="flex items-center text-on-surface no-underline"
    >
      {blok.title}
      <OpenNewTabIcon className="ml-2" width={16} height={16} aria-label={strings?.links.open_in_new_tab} />
    </Link>
  )
}

export default SourceLink
